import React from "react";
import { motion } from "framer-motion";

const profileDoodles = [
  { icon: "📝", top: "10%", left: "5%", delay: 0 },
  { icon: "✨", top: "15%", right: "10%", delay: 0.5 },
  { icon: "📖", bottom: "25%", left: "8%", delay: 1 },
  { icon: "🖋️", bottom: "15%", right: "12%", delay: 1.5 },
  { icon: "☁️", top: "40%", left: "12%", delay: 0.8 },
  { icon: "🌟", top: "50%", right: "5%", delay: 1.2 },
  { icon: "🎨", bottom: "10%", left: "45%", delay: 0.4 },
];

const Profile = () => {
  return (
    <motion.div 
      className="category-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{ position: "relative", overflow: "hidden", minHeight: "100vh" }}
    >
      {/* --- Background Doodles --- */}
      {profileDoodles.map((d, index) => (
        <motion.div
          key={index}
          className="floating-doodle"
          style={{ 
            top: d.top, left: d.left, right: d.right, bottom: d.bottom,
            position: "absolute", fontSize: "2.5rem", opacity: 0.3, zIndex: 0,
            pointerEvents: "none"
          }}
          animate={{ y: [0, -20, 0], rotate: [0, 10, -10, 0] }}
          transition={{ duration: 6, repeat: Infinity, delay: d.delay, ease: "easeInOut" }}
        >
          {d.icon}
        </motion.div>
      ))}

      <div className="profile-container" style={{ maxWidth: "800px", margin: "0 auto", textAlign: "center", position: "relative", zIndex: 1 }}>
        
        {/* --- Foto Profil --- */}
        <motion.div 
          className="profile-image-wrapper"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{ marginBottom: "20px", marginTop: "50px" }}
        >
          <img 
            src="/posters/bia.jpeg" 
            alt="Bia"
            style={{ 
              width: "160px", height: "160px", borderRadius: "50%", 
              objectFit: "cover", border: "5px solid #fff",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
            }}
            onError={(e) => {e.target.src = "https://via.placeholder.com/160?text=Bia"}}
          />
        </motion.div>

        {/* --- Nama & Bio --- */}
        <h2 className="main-title" style={{ fontSize: "2.2rem", marginBottom: "5px" }}>Hi, I'm Bia ✨</h2>
        <p className="subtitle" style={{ fontStyle: "italic", color: "#666", maxWidth: "600px", margin: "0 auto 20px auto", fontSize: "0.95rem" }}>
          "A dreamer, a writer, and a curious soul exploring the world through art and words."
        </p>

        {/* --- PINDAH KE SINI: Social Links --- */}
        <div style={{ display: "flex", justifyContent: "center", gap: "15px", marginBottom: "30px" }}>
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.open("https://instagram.com/robiarchives", "_blank")}
            style={{ padding: "8px 20px", borderRadius: "20px", border: "1px solid #eee", background: "white", cursor: "pointer", fontSize: "0.85rem", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}
          >
            Instagram 📸
          </motion.button>
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.open("https://medium.com/@obywrites", "_blank")}
            style={{ padding: "8px 20px", borderRadius: "20px", border: "1px solid #eee", background: "white", cursor: "pointer", fontSize: "0.85rem", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}
          >
            Medium 📝
          </motion.button>
        </div>

        <hr style={{ width: "30px", margin: "0 auto 30px auto", border: "0.5px solid #eee" }} />

        {/* --- Detail Section (About & Interests) --- */}
        <div className="profile-details" style={{ textAlign: "left", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px", padding: "0 20px" }}>
          <div style={{ opacity: 0.9 }}>
            <h4 style={{ fontSize: "1rem", marginBottom: "10px", color: "#333" }}>About Me</h4>
            <p style={{ fontSize: "0.85rem", lineHeight: "1.6", color: "#555" }}>
              Seorang penikmat film dan buku yang percaya bahwa setiap cerita punya nyawa. 
              Melalui WorldOfBia, aku ingin membagikan potongan-potongan inspirasi yang aku temukan di sepanjang perjalananku.
            </p>
          </div>

          <div style={{ opacity: 0.9 }}>
            <h4 style={{ fontSize: "1rem", marginBottom: "10px", color: "#333" }}>Interests</h4>
            <ul style={{ fontSize: "0.85rem", lineHeight: "1.8", color: "#555", listStyle: "none", padding: 0 }}>
              <li>🎬 Cinematic Storytelling</li>
              <li>📚 Literature</li>
              <li>🌍 Cultural Traveling</li>
              <li>🎵 Indie & Pop Melancholy</li>
            </ul>
          </div>
        </div>

      </div>
    </motion.div>
  );
};

export default Profile;